import { PhysicalModel, TypeEnseigne } from '../types/graphql-global-types';

export const getEnseigneType = (type: string): TypeEnseigne => {
  if (type === 'CONNECTCREDIT') return TypeEnseigne.CONNECTCREDIT;
  if (type === 'TRANSACTION IMMOBILIERE')
    return TypeEnseigne.REAL_ESTATE_TRANSACTION;
  if (type === 'NOTARIAL') return TypeEnseigne.NOTARIAT;
  if (type === 'BANQUE') return TypeEnseigne.BANK;
  if (type === 'PROMOTION IMMOBILIERE')
    return TypeEnseigne.REAL_ESTATE_PROMOTION;
  if (type === 'GESTION PATRIMONIALE') return TypeEnseigne.HERITAGE_MANAGEMENT;
  if (type === 'ASSURANCE') return TypeEnseigne.INSURANCE;
  if (type === 'PARRAINAGE') return TypeEnseigne.PARRAINAGE;
  return TypeEnseigne.OTHER; // default
};

export const getPhysicalModel = (model: string): PhysicalModel => {
  if (model === 'AVEC AGENCE') return PhysicalModel.WITH_AGENCY;
  if (model === 'SANS AGENCE') return PhysicalModel.WITHOUT_AGENCY;
  return PhysicalModel.WITHOUT_AGENCY; // default
};
